import ageOptionData from '@selector-options/age'
import incomeOptionData from '@selector-options/income'
import stateOptionData from '@selector-options/states'
import heightData from '@selector-options/height'
import weightData from '@selector-options/weight'

export const fillLeadgenQuestionsData = (leadgenData) => {
  leadgenData.questions.forEach(question => {
    switch (question.key) {
      case "age": {
        question.options = ageOptionData
        break
      }
      case "income_estimated": {
        question.options = incomeOptionData
        break
      }
      case "address_state": {
        question.options = stateOptionData
        break
      }
      case "height": {
        question.options = heightData
        break
      }
      case "weight": {
        question.options = weightData
        break
      }
    }
  })

  return leadgenData
}
